import CreditScoreIcon from '@mui/icons-material/CreditScore';

function Payment() {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '90%',
        }}
      >
        <p
          style={{
            fontSize: '23px',
            textAlign: 'center',
            paddingLeft: '5%',
            paddingRight: '5%',
          }}
        >
          Basic delivery has been covered by a delivery credit from ePharmNI*
        </p>
        <CreditScoreIcon
          sx={{
            paddingTop: '3%',
            marginBottom: '3%',
            scale: '2.5',
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '10%',
        }}
      >
        <p
          style={{
            color: '#868080',
            fontSize: '14px',
            textAlign: 'center',
            paddingLeft: '5%',
            paddingRight: '5%',
          }}
        >
          *Coming soon you will be able to pay to upgrade your delivery to a nominated day service
        </p>
      </div>
    </>
  );
}

export default Payment;
